export enum GridApplicationProcessActionTypes {
  External = 1,
  Internal = 2,
  AddNewProduct = 3,
}
